<script setup lang="ts">
import { computed, type PropType, toRef } from 'vue'
import type { Field } from '@/components/form/type/type.ts'

const props = defineProps({
  field: { type: Object as PropType<Field>, required: true },
  modelValue: { type: Object, required: true },
  label: { type: String, required: false },
  itemKey: { type: String, required: false },
  noLabel: { type: Boolean, required: false, default: false },
  position: { type: String as PropType<'front' | 'back'>, required: false, default: 'front' },
  showCheckBox: { type: Boolean, required: false, default: true }
})

const emit = defineEmits<{
  update: []
  'update:modelValue': [Record<string, any>]
  'click:prepend-inner': []
}>()

const modelValue = toRef(props, 'modelValue')

const label = computed(() => {
  return props.noLabel ? undefined : props.label ? props.label : props.field.label
})

const itemKey = computed(() => {
  return props.itemKey ?? props.field.parameter
})

const value = computed({
  get: () => modelValue.value[itemKey.value],
  set: (value) => {
    modelValue.value[itemKey.value] = value
    emit('update:modelValue', props.modelValue)
    emit('update')
  }
})
</script>

<template>
  <div style="display: flex; align-items: center">
    <template v-if="position === 'front'">
      <v-checkbox
        color="primary"
        v-model="value"
        v-bind="$attrs"
        :style="{ visibility: showCheckBox ? 'visible' : 'hidden' }"
      ></v-checkbox>
      <span v-if="label" style="min-width: 140px; display: inline-block">{{ label }}</span>
      <span v-else style="min-width: 140px; display: inline-block"></span>
    </template>
    <template v-else>
      <span v-if="label" style="min-width: 140px; display: inline-block">{{ label }}</span>
      <span v-else style="min-width: 140px; display: inline-block"></span>
      <v-checkbox
        color="primary"
        v-model="value"
        v-bind="$attrs"
        :style="{ visibility: showCheckBox ? 'visible' : 'hidden' }"
      ></v-checkbox>
    </template>
  </div>
</template>
